<script>
import {ref} from "vue";
import Swal from "sweetalert2";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {CallNumber} from "capacitor-call-number";
import FreeWorld from "@/assets/js/FreeWorld";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FooterPage from "@/components/assetComponents/FooterPage.vue";

export default {
  name: 'SupportPage',
  components: {FooterPage, NavbarPage, LoadingPage},

  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let load_page = ref(false)

    let text_ticket = ref('')
    let title = ref('')

    let app = ref(false)
    let buy = ref(false)
    let more = ref(false)
    let nazarat = ref(false)

    let suport_phone = ref()


    function select_tiket(action) {

      if (action == 'app_error') {
        app.value = true
        title.value = 'مشکل خاص در اپلیکیشن'
        buy.value = false
        more.value = false
        nazarat.value = false
      } else if (action == 'buy_error') {
        buy.value = true
        app.value = false
        more.value = false
        nazarat.value = false
        title.value = 'بروز مشکل در خرید'
      } else if (action == 'more_error') {
        more.value = true
        app.value = false
        buy.value = false
        nazarat.value = false
        title.value = 'سایر موارد'
      } else if (action == 'comments') {
        nazarat.value = true
        app.value = false
        more.value = false
        buy.value = false
        title.value = 'انتقاد و پیشنهاد'
      }

    }

    function send_ticket() {
      if (title.value == '') {
        Swal.fire({
          icon: 'warning',
          title: 'لطفا موضوع تیکت خود را انتخاب کنید',
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })
      } else if (text_ticket.value == '') {
        Swal.fire({
          icon: 'warning',
          title: 'لطفا مشکل خود را شرح دهید',
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })
      } else {

        let data = {
          subject: title.value,
          text: text_ticket.value,
          action: 'add',
        }

        load_page.value = true
        FreeWorld.Heisenberg(data, 'tickets', true).then((result) => {

          load_page.value = false
          let res = result.data
          if (res.status == 'ok') {

            Swal.fire({
              position: 'center-center',
              icon: 'success',
              title: 'تیکت شما با موفقیت ثبت شد',
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {

              text_ticket.value = ''
              app.value = false
              more.value = false
              buy.value = false
              nazarat.value = false

            })

          } else {

            Swal.fire({
              position: 'center-center',
              icon: 'success',
              title: 'متاسفانه تیکت شما ثبت نشد',
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {

              text_ticket.value = ''
              app.value = false
              more.value = false
              buy.value = false
              nazarat.value = false

            })

          }


        }).catch((result) => {
          load_page.value = false
          if (result.message == 'Network Error') {
            Swal.fire({
              icon: 'error',
              confirmButtonText: 'تلاش مجدد',
              text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
            }).then((result) => {
              if (result.isConfirmed) {
                send_ticket()
              }
            })
          } else {
            Swal.fire({
              icon: 'error',
              confirmButtonText: 'تلاش مجدد',
              text: '!خطای ارتباط با سرور',
            }).then((result) => {
              if (result.isConfirmed) {
                send_ticket()
              }
            })
          }
        })
      }
    }

    function load_support() {
      FreeWorld.Heisenberg({}, 'unit/support').then((result) => {

        var res = result.data
        suport_phone.value = res.phone

      }).catch((result) => {

        load_page.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              load_support()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              load_support()
            }
          })
        }
      })
    }
    load_support()


    function call_support() {
      const userAgent = navigator.userAgent;
      if (userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/)) {
        CallNumber.call({number: suport_phone.value, bypassAppChooser: true});
      } else {
        Swal.fire({
          title: 'شماره پشتیبانی',
          text: suport_phone.value,
          confirmButtonText: 'متوجه شدم',
        })
      }
    }

    return {
      text_ticket,
      app,
      buy,
      nazarat,
      more,
      send_ticket,
      load_page,
      suport_phone,
      select_tiket,
      call_support,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="load_page"></LoadingPage>

  <div id="main" :class="load_page ? 'activeClass' : '' " class="bg-main">
    <div class="div-top-arrow bg-color d-flex align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0">
          پشتیبانی
        </p>
        <div onclick="history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body mt-2 animate__animated animate__fadeIn">
      <p class="font-4 font-bold text-end p-body">
        انتخاب موضوع تیکت
      </p>
      <div class="d-flex justify-content-between w-100">
        <div @click="select_tiket('app_error')" :class="app ? 'active_ticket' : 'bg-white'"
             class="w-45 border-costom text-center font-4 rounded-3 py-3 px-2">
          مشکل خاص در اپلیکیشن
        </div>
        <div @click="select_tiket('buy_error')" :class="buy ? 'active_ticket' : 'bg-white'"
             class="w-45 border-costom text-center font-4 rounded-3 py-3 px-2">
          بروز مشکل در خرید
        </div>
      </div>
      <br>
      <div class="d-flex justify-content-between w-100">
        <div @click="select_tiket('more_error')" :class="more ? 'active_ticket' : 'bg-white'"
             class="w-45 border-costom text-center font-4 rounded-3 py-3 px-2">
          سایر موارد
        </div>
        <div @click="select_tiket('comments')" :class="nazarat ? 'active_ticket' : 'bg-white'"
             class="w-45 border-costom text-center font-4 rounded-3 py-3 px-2">
          انتقاد و پیشنهاد
        </div>
      </div>
      <br>
      <p class="font-4 font-bold text-end p-body">
        مشکل خود را شرح دهید
      </p>
      <textarea v-model="text_ticket" class="textarea_comment_user bg-white rounded-4 border-costom w-100 p-3 font-4"
                placeholder="توضیحات مورد نظر خود را وارد نمایید"></textarea>
      <br>
      <br>
      <div class="w-100 d-flex justify-content-center">
        <v-btn @click="send_ticket" class="bg-color h-75 p-3 rounded-3 text-white border-costom w-90 ">
          ارسال تیکت
        </v-btn>
      </div>
      <br>
      <div class="w-100 d-flex justify-content-center">
        <router-link to="/TiketPage" class="text-black font-4" href="">
          تیکت های من
        </router-link>
      </div>
      <br>
      <br>
      <br>
      <div class="call_support">
        <div @click="call_support" class="text-decoration-none">
          <img style="width: 100px; height: 100px" src="../assets/img/call_support.svg" alt="">
          <p class="m-0 font-4 px-2">
            تماس مستقیم
          </p>
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
  </div>

  <div id="web" :class="load_page ? 'activeClass' : '' " class="bg-main">

    <NavbarPage></NavbarPage>
    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-4 w-75 ma-auto">پشتیبانی</div>

    <div class="bg-white p-4 rounded-4 w-75 m-auto">
      <p class="font-4 font-bold mb-3 text-end p-body">
        انتخاب موضوع تیکت
      </p>

      <div class="d-flex justify-content-between w-100">
        <div @click="select_tiket('app_error')" :class="app ? 'active_ticket' : 'bg-white'"
             class="w-45 border-costom text-center font-4 rounded-3 py-3 px-2">
          مشکل خاص در اپلیکیشن
        </div>
        <div @click="select_tiket('buy_error')" :class="buy ? 'active_ticket' : 'bg-white'"
             class="w-45 border-costom text-center font-4 rounded-3 py-3 px-2">
          بروز مشکل در خرید
        </div>
      </div>

      <br>

      <div class="d-flex justify-content-between w-100">
        <div @click="select_tiket('more_error')" :class="more ? 'active_ticket' : 'bg-white'"
             class="w-45 border-costom text-center font-4 rounded-3 py-3 px-2">
          سایر موارد
        </div>
        <div @click="select_tiket('comments')" :class="nazarat ? 'active_ticket' : 'bg-white'"
             class="w-45 border-costom text-center font-4 rounded-3 py-3 px-2">
          انتقاد و پیشنهاد
        </div>
      </div>

      <br>

      <p class="font-4 font-bold mb-3 text-end p-body">
        مشکل خود را شرح دهید
      </p>

      <textarea v-model="text_ticket" class="textarea_comment_user bg-white rounded-4 border-costom w-100 p-3 font-4"
                placeholder="توضیحات مورد نظر خود را وارد نمایید"></textarea>
      <br>
      <br>

      <div class="w-100 d-flex justify-content-center">
        <v-btn @click="send_ticket" class="bg-color h-75 p-3 rounded-3 text-white border-costom w-90 ">
          ارسال تیکت
        </v-btn>
      </div>

      <br>

      <div class="w-100 d-flex justify-content-center">
        <router-link to="/TiketPage" class="text-black font-4" href="">
          تیکت های من
        </router-link>
      </div>

      <br>
      <br>
      <br>

      <div class="call_support">
        <div @click="call_support" class="text-decoration-none">
          <img style="width: 100px; height: 100px" src="../assets/img/call_support.svg" alt="">
          <p class="m-0 font-4 px-2">
            تماس مستقیم
          </p>
        </div>
      </div>

    </div>
    <br>
    <br>
    <br>

    <FooterPage></FooterPage>
  </div>

</template>

<style scoped>

.textarea_comment_user {
  height: 200px;
  resize: none;
}

.textarea_comment_user::placeholder {
  text-align: center;
}

.call_support {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: left;
  width: 100%;
}

.active_ticket {
  background-color: #FF9900;
  color: white;
}

</style>